import {Injectable} from '@angular/core';
import {AuthHttpService} from "./auth-http.service";
import {AppResponse} from "./app-response.model";
import {Observable} from "rxjs/index";
import {optimistic} from "./common-http.service";
import {ReturnParameters} from "../model/return/parameters";

@Injectable({
  providedIn: 'root'
})

export class ReturnApiService {

  constructor(
    private authHttp: AuthHttpService
  ) {
  }

  returnItem(orderItemId: number, parameters: ReturnParameters): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/return/item/" + orderItemId.toString(), parameters);
  }

  generateReport(orderItemId: number, parameters: ReturnParameters) {
    return this.authHttp.postBlob("/return/report/" + orderItemId.toString(), parameters).pipe(optimistic);
  }
}
